import { Mail } from 'src/models/mail';

import { Callback } from 'src/util/query/models/Callback';

export class MailCallback extends Callback<Mail> {
	public constructor(private readonly setMail: (mail: Mail | null) => void) {
		super();
	}

	failureCallbackFunction = (failureResponse: unknown): void => {
		this.logFailureResponse(failureResponse);
	};

	successCallbackFunction = (successResponse: Mail): void => {
		this.setMail(successResponse);
	};
}
